module.exports = __webpack_public_path__ + "img/C10.61508863.jpg";